"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductionDashboardData = void 0;
const product_dashboard_order_line_product_response_1 = require("./product-dashboard-order-line-product.response");
const product_dashboard_order_line_response_1 = require("./product-dashboard-order-line.response");
const product_dashboard_sales_order_release_response_1 = require("./product-dashboard-sales-order-release.response");
const product_dashboard_sales_order_response_1 = require("./product-dashboard-sales-order.response");
class ProductionDashboardData {
}
exports.ProductionDashboardData = ProductionDashboardData;
//# sourceMappingURL=production-dashboard-data.response.js.map